import { render, staticRenderFns } from "./testInfo.vue?vue&type=template&id=77c2587f&scoped=true&"
import script from "./testInfo.vue?vue&type=script&lang=js&"
export * from "./testInfo.vue?vue&type=script&lang=js&"
import style0 from "./testInfo.vue?vue&type=style&index=0&id=77c2587f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2587f",
  null
  
)

export default component.exports